export enum RouteParamnames {
    projectId = 'projectId',
    townId = 'townId',
    id = 'id'
}
